import React, { useState,useEffect } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import CryptoJS from "crypto-js";
import { useNavigate,useSearchParams } from "react-router-dom";
import './dashboard.css'

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

useEffect(() => {
  const user = searchParams.get("user");
  const pass = searchParams.get("pass");

  
    const url = new URL(window.location);
    url.searchParams.delete("user");
    url.searchParams.delete("pass");
    window.history.replaceState({}, "", url.toString());


  if (user && pass) {
    setUsername(atob(user));
    setPassword(atob(pass));
  }
}, [searchParams]);  // Make sure to trigger the effect only when searchParams change.

useEffect(() => {
  if (username && password) {  // Make sure both username and password are set before logging in
     handleLogin(null);
  }
}, [username, password]); // This will run after username and password are updated



  // Simulate the stored user with hashed password
  const storedUsername = "c5e0407177d355aef448d24c431cb2366b71302e3b994e91dd6ab4b19e4089c0";
  const storedHashedPassword = "cf8e8c1a060ce9b72918c482db21b339091ed3902cee720db7254647805d46a1"; // Simulated hashed password

  // Encrypt and hash password using CryptoJS (for frontend simulation)
  const hashPassword = (password) => {
    return CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
  };

  // Generate a token for user session (store in localStorage)
  const generateToken = () => {
    const token = `${Date.now()}_${Math.random().toString(36).substr(2)}`;
    localStorage.setItem("authToken", token);
    localStorage.setItem("tokenExpiry", Date.now() + 86400000); // Token expires in 1 day
    return token;
  };

  // Verify token (check if it exists and hasn't expired)


  const handleLogin = (e) => {
    if(e)
    {e.preventDefault();}

    setError("");
    setLoading(true);

    // Hash the input password and compare it with stored hashed password
    const hashedInputPassword = hashPassword(password);
    const hashedInputUsername = hashPassword(username);

    if (hashedInputUsername === storedUsername && hashedInputPassword === storedHashedPassword) {
      const token = generateToken(); // Generate token upon successful login
      navigate('/')
    } else {
      setError("Invalid username or password.");
    }

    setLoading(false);
  };

  return (
    <Container maxWidth="sm" marginTop="100px" >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 3,
          backgroundColor: "#f4f4f4",
          borderRadius: 2,
          boxShadow: 3,
          marginTop:"100px"
        }}
        className="container"
      >
        <Typography variant="h5" component="h1" gutterBottom sx={{ color: "rgb(0, 0, 0)" }}>
          Login
        </Typography>
        
        {error && <Typography color="error" sx={{ marginBottom: 2 }}>{error}</Typography>}
        
        <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            label="Username"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            sx={{ marginBottom: 2 }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ marginBottom: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ backgroundColor: "rgb(234, 127, 47)" }} // Corrected here
                disabled={loading}
            >
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default Login;
